import { i18n as I18nInstance } from 'i18next';
import { formatAzerbaijaniNumberEnding } from './azerbaijaniNumberEnding';

export const registerI18nFormatters = (i18n: I18nInstance) => {
  const { formatter } = i18n.services;
  if (!formatter) return;

  formatter.add('azNumberEnding', value =>
    formatAzerbaijaniNumberEnding(value)
  );
};
